// @ts-nocheck
import * as React from "react";
import { useState } from "react";
import "./datePicker.scss";
import moment from "moment";
import classNames from "classnames";
import { DatePicker } from "antd";
import { formatDate, formatDateTz } from "utils/utilities";
import _ from "lodash";
import { usePopupParent } from "hooks/usePopupParent";

interface Props {
  selectedDate: string | moment.Moment | (string | moment.Moment)[];
  handleClick: React.ChangeEventHandler;
  name: string;
  min?: string;
  max?: string;
  placeholder?: string | string[];
  isRange?: boolean;
  allowEmpty?: boolean;
}

const { RangePicker } = DatePicker;

const DateWrapper = (props: Props) => {
  const {
    selectedDate,
    handleClick,
    name,
    min,
    max,
    placeholder,
    isRange,
    allowEmpty,
  } = props;
  const getPopupParent = usePopupParent("full-screen");

  const [resetKey, setResetKey] = useState(0);

  const classes: any = classNames(["datePicker"]);

  const getRangeValue = (): [moment.Moment, moment.Moment] | null => {
    if (!selectedDate || !Array.isArray(selectedDate)) return null;
    const [start, end] = selectedDate;
    if (start && end) {
      const momentStart = formatDateTz(start);
      const momentEnd = formatDateTz(end);
      if (momentStart?.isValid() && momentEnd?.isValid()) {
        return [momentStart, momentEnd];
      }
    }
    return null;
  };

  const getSingleValue = (): moment.Moment | null => {
    if (!selectedDate || Array.isArray(selectedDate)) return null;
    const momentDate = formatDateTz(selectedDate);
    return momentDate?.isValid() ? momentDate : null;
  };

  if (isRange) {
    const rangeValue = getRangeValue();

    return (
      <RangePicker
        key={`range-picker-${resetKey}`}
        getPopupContainer={getPopupParent}
        allowEmpty={allowEmpty && isRange ? [true, true] : [false, false]}
        disabledDate={(d) =>
          !d || (min && d.isBefore(min)) || (max && d.isAfter(max))
        }
        className={classes}
        value={rangeValue}
        placeholder={placeholder}
        format={"MM/DD/YYYY"}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onChange={(d) => {
          if (!d || d.length === 0) {
            // If cleared, increment the key counter to force remount
            setResetKey((prevKey) => prevKey + 1);
          }
          handleClick({
            target: {
              value: d || [],
              name,
            },
          });
        }}
        allowClear={true}
        onKeyDown={(e) => {
          if (e.key === "Backspace" || e.key === "Delete") {
            const inputElement = e.target as HTMLInputElement;
            setTimeout(() => {
              if (inputElement.value === "") {
                handleClick({
                  target: {
                    value: "",
                    name,
                  },
                });

                setResetKey((prevKey) => prevKey + 1);
              }
            }, 0);
          }
        }}
      />
    );
  }

  // Single DatePicker logic
  const singleValue = getSingleValue();

  return (
    <DatePicker
      key={`date-picker-${resetKey}`}
      getPopupContainer={getPopupParent}
      className={classes}
      disabledDate={(d) =>
        !d || (min && d.isBefore(min)) || (max && d.isAfter(max))
      }
      value={singleValue}
      name={name}
      placeholder={placeholder as string}
      format={"MM/DD/YYYY"}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key === "Backspace" || e.key === "Delete") {
          const inputElement = e.target as HTMLInputElement;
          setTimeout(() => {
            if (inputElement.value === "") {
              handleClick({
                target: {
                  value: "",
                  name,
                },
              });

              setResetKey((prevKey) => prevKey + 1);
            }
          }, 0);
        }
      }}
      onChange={(d) => {
        if (!d) {
          setResetKey((prevKey) => prevKey + 1);
        }
        handleClick({
          target: {
            value: d || "",
            name,
          },
        });
      }}
      allowClear={true}
    />
  );
};

export default DateWrapper;
